import { render, staticRenderFns } from "./dialogForm2.vue?vue&type=template&id=229858d4&scoped=true"
import script from "./dialogForm2.vue?vue&type=script&lang=js"
export * from "./dialogForm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229858d4",
  null
  
)

export default component.exports